// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2QyVl","dragIcon":"SortableItem_dragIcon__3sQQW","disabled":"SortableItem_disabled__11izE"};